import React from "react";
import cookie from "js-cookie";
import { useForm } from "react-hook-form";
import server from "../../api/server";
import { Input } from "../../components/shared/FormComponents";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useState } from "react";
import { FormattedMessage } from 'react-intl';


const MetaEditComponent = ({ title, slug, data }) => {
	const [, setLoading] = useState(false);
	const {
		register,
    handleSubmit,
		formState: { errors },
		reset,
	} = useForm();

	const onStart = async () => {
		try {
			reset({
				name: {
					ar: data?.name?.ar,
					en: data?.name?.en,
				},
				description: {
					ar: data?.name?.ar,
					en: data?.name?.en,
				},
			});
		} catch (error) {
			console.log(error);
		}
	};

	const submitHandler = async data => {
		setLoading(true);
		console.log("first");
		try {
			const finalData = data;

			const dataResponse = await server(cookie).put(
				`/pages/metaData/sections/${slug}`,
				{
					section: finalData,
				}
			);
			toast.success("تم تعديل البيانات بنجاح");

			console.log(
				dataResponse?.data?.data?.sections?.find(
					section => section?.slug === slug
				)
			);
			reset(
				dataResponse?.data?.data?.sections?.find(
					section => section?.slug === slug
				)
			);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);

	return (
		<form onSubmit={handleSubmit(submitHandler)} style={{marginBottom:"100px"}}>
			<div className="row">
				<div className="col-md-">
					<div className="card">
						<div className="row mb-3">
							<h2
								style={{
									fontSize: "18px",
									margin: "20px",
								}}
							>
								{<FormattedMessage id={title}/>}
							</h2>
							<div className="col-md-6">
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="nameEn">الميتا تايتل باللغه العربيه</label>
										<Input
											type="text"
											name="name.ar"
											id="metaTitleAr"
											register={register}
											required={true}
										/>
									</div>
								</div>
							</div>

							<div className="col-md-6">
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="nameEn">
											الميتا تايتل باللغه الانجليزيه
										</label>
										<Input
											type="text"
											name="name.en"
											id="metaTitleAr"
											register={register}
											required={true}
										/>
									</div>
								</div>
							</div>

							<div className="col-md-6">
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="nameEn">وصف الميتا بالعربيه </label>

										<textarea
											name="description.ar"
											id="metaDescAr"
											{...register("description.ar", { required: true })}
										/>
									</div>
								</div>
							</div>

							<div className="col-md-6">
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="nameEn">وصف الميتا بالانجليزيه</label>

										<textarea
											name="description.en"
											id="metaDescAr"
											{...register("description.en", { required: true })}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="form-item mt-3  d-flex justify-content-center">
							<button type="submit" className="bt bt-success btn-block w-25">
								ارسال
							</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	);
};

export default MetaEditComponent;
